import { Icon } from '@iconify/react';
import { styled } from '@linaria/react';
import { ActionIcon, Modal } from '@mantine/core';
import { MouseEvent, useState } from 'react';
import { newCOLORS } from '../../../styles/colors';

type Props = {
  imageData: string;
  index: number;
};

export const FloraPNGImage = ({ imageData, index }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDownload = (e: MouseEvent) => {
    e.stopPropagation();
    const link = document.createElement('a');
    link.href = `data:image/png;base64,${imageData}`;
    link.download = `attachment-${index + 1}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExpand = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <PreviewContainer
        onClick={handleExpand}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleExpand();
          }
        }}
        aria-label={`Open attachment ${index + 1}`}
        tabIndex={0}
        role="button"
      >
        <PreviewImage src={`data:image/png;base64,${imageData}`} alt={`Attachment ${index + 1}`} />
        <Overlay className="overlay">
          <ActionIcon
            variant="filled"
            color="white"
            size="md"
            aria-label="Zoom in"
            onClick={handleExpand}
            style={{ backgroundColor: 'rgba(255, 255, 255, 0.9)' }}
          >
            <Icon icon="material-symbols:zoom-in" style={{ color: newCOLORS.darkGray }} />
          </ActionIcon>
          <ActionIcon
            variant="filled"
            color="white"
            size="md"
            aria-label="Download"
            onClick={handleDownload}
            style={{ backgroundColor: 'rgba(255, 255, 255, 0.9)' }}
          >
            <Icon icon="material-symbols:download" style={{ color: newCOLORS.darkGray }} />
          </ActionIcon>
        </Overlay>
      </PreviewContainer>

      <Modal
        opened={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        size="auto"
        centered
        withCloseButton={false}
        padding="md"
      >
        <FullImage src={`data:image/png;base64,${imageData}`} alt={`Flora PNG Image ${index + 1}`} />
      </Modal>
    </>
  );
};

const PreviewContainer = styled.div`
  position: relative;
  display: inline-block;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 4px;
  cursor: pointer;
  transition: transform 0.2s ease;
  border: 1px solid ${newCOLORS.lightGray};
  
  &:hover {
    transform: scale(1.02);
    
    .overlay {
      opacity: 1;
    }
  }
`;

const PreviewImage = styled.img`
  width: 200px;
  height: 120px;
  object-fit: cover;
  display: block;
  border-radius: 8px;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.2s ease;
  border-radius: 8px;
`;

const FullImage = styled.img`
  max-width: 100%;
  max-height: 80vh;
  height: auto;
  display: block;
  margin: 0 auto;
  border-radius: 8px;
`;
